import { atom } from "recoil"

export const newComponentState = atom({
    key: "NewComponentState",
    default: {} as { projectId: string; envId: string; name: string }
});
